export const RedFlagPolicyLink = 'https://chnnl.app/red-flag-policy'
